import { Pagination, Navigation } from "swiper";
import NETWORKS from "./network";

export const BASE_URL = process.env.STRAPE_BASE_URI || "";
export const AUTHENTICATION_URL =
  `Bearer ${process.env.STRAPE_API_ACCESS_TOKEN}` || "";

export const metaMaskExtensionInstallationLink =
  "https://metamask.app.link/dapp/window.location/";
export const FILE_UPLOAD_URL = BASE_URL + "/api/upload";

export const GET_TRANSACTION_LINK = (chainId, transactionHash) =>
  chainId ? `${NETWORKS[chainId].blockExplorer}/tx/${transactionHash}` : "";

export const PROJECT_STATUSES = {
  LIVE: "Live",
  COMPLETED: "Completed",
  UPCOMING: "Upcoming",
  DRAFT: "Draft",
  ALL: "All",
};

export const RAISE_TYPES = {
  Old_Dutch_Auction: "Dutch Auction",
  Dutch_Auction: "Dutch Auction",
  Fixed_Raise: "Fixed Price",
};

export const PROJECT_TAGS = {
  FEATURED: "Featured",
  FLAGGED: "Flagged",
};

export const transactionType = {
  Buy: "SaleBuy",
  Refund: "SaleRefund",
};

export const ELIGIBILITY_STATUSES = {
  INELIGIBLE: 0,
  ELIGIBLE: 1,
};

export const PARTIAL_TIME_FORMAT = "DD/MM/YYYY - hh:mm A";

export const COMPLETE_TIME_FORMAT = "DD/MM/YYYY - hh:mm A";

export const REWARD_DISTRIBUTION_DATE_FORMAT = "DD MMM, YYYY - hh:mma";

export const MUMBAI_TESTNET_HEX_CHAIN_ID = "0x13881";

export const CAN_START_SOURCE = "0x050001000b00";

export const sliderOptions = {
  slidesPerView: 4,
  slidesPerGroup: 4,
  spaceBetween: 0,
  loop: false,
  navigation: true,
  modules: [Pagination, Navigation],
  pagination: {
    clickable: true,
  },
  breakPoint: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
    },
    600: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    1300: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
};

export const partnerSliderOptions = {
  slidesPerView: 4,
  slidesPerGroup: 4,
  spaceBetween: 0,
  loop: false,
  navigation: true,
  modules: [Pagination, Navigation],
  pagination: {
    clickable: true,
  },
  breakPoint: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
    },
    600: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    1500: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
};

export const ABSOLUTE_ZERO_REGEX = /[.,]0$/;

export const TRANSACTION_FEE_PERCENTAGE = 1;

export const wrongChainMessage = {
  80001: "Incorrect chain - please switch to the Mumbai network",
  137: "Incorrect chain - please switch to the Polygon network",
};
